import React, { useState, useMemo } from "react";
import OidcBackendMetaContext from "authentication/components/oidc/config/components/OidcBackendMetaContext";
const OidcBackendMetaProvider = ({ children, defaultValue }) => {
  const [contextValue, setContextValue] = useState(defaultValue);
  const oidcBackendMetaContextValue = useMemo(() => ({ ...contextValue, setContextValue }), [contextValue]);
  return /* @__PURE__ */ React.createElement(OidcBackendMetaContext.Provider, { value: oidcBackendMetaContextValue }, children);
};
export { OidcBackendMetaContext };
export default OidcBackendMetaProvider;
